import LOSBranchViewPage from "./LOSBranchViewPage";

export default LOSBranchViewPage;